import { Component, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-strelci-add-dialog',
  templateUrl: './strelci-add-dialog.component.html',
  styleUrls: ['./strelci-add-dialog.component.scss']
})
export class StrelciAddDialogComponent implements OnInit {
  @Input() strelci: any = {
    full_name: '',
    spol: '',
    klub: '',
    koda_kluba: '',
    member_id: 0
  };

  @Input() isEditMode = false;

  clubs: any[] = [];

  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  constructor(private http: HttpClient) {}

  ngOnInit() {
    const apiUrl = 'https://testapi.ovh/api/strelstvo/clubs';
    this.http.get<any[]>(apiUrl, this.requestOptions()).subscribe(
      clubs => this.clubs = clubs,
      err => this.clubs = []
    );
  }

  ngOnChanges() {
    if (this.strelci) {
      // Optionally, patch the form or assign values here
    }
  }

  onSave() {
    // Prepare the payload for the API
    const payload = {
      member_id: this.strelci.member_id,
      club_id: this.strelci.klub,
      full_name: this.strelci.full_name,
      gender: this.strelci.spol
    };

    console.log('Saving member with payload:', payload);

    if (this.isEditMode) {
      // EDIT: Use PUT and send member_id as a parameter
      const apiUrl = `https://testapi.ovh/api/strelstvo/members/${this.strelci.member_id}`;
      this.http.put(apiUrl, payload, this.requestOptions()).subscribe(
        (response) => {
          console.log('Update response:', response);
          this.save.emit(response);
        },
        (error) => {
          console.error('Error updating member:', error);
          alert('Napaka pri urejanju strelca!');
        }
      );
    } else {
      // ADD: Use POST
      const apiUrl = 'https://testapi.ovh/api/strelstvo/members';
      this.http.post(apiUrl, payload, this.requestOptions()).subscribe(
        (response) => {
          console.log('Save response:', response);
          this.save.emit(response);
        },
        (error) => {
          console.error('Error saving member:', error);
          alert('Napaka pri shranjevanju strelca!');
        }
      );
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  private requestOptions(): { headers: HttpHeaders; params: HttpParams } {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    return {
      headers: token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders(),
      params: unitId ? new HttpParams().set('unit_id', unitId) : new HttpParams()
    };
  }
}
